$(document).ready(function(){
  if ($('.estimateTimer').length) {
    var startTime = new Date();
    var endTime = new Date(startTime.getFullYear()+"/"+(startTime.getMonth()+1)+"/"+startTime.getDate()+' '+$('.estimateTimer').parent("b").find(".dateEstimate").data("delivery_cutoff"));
    var timer_time = Math.round((endTime - startTime) / 60000);

    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + $('.estimateTimer').parent("b").find(".dateEstimate").data("date"));

    if(timer_time <= 0){
      endTime.setDate(endTime.getDate() + 1);
      timer_time = Math.round((endTime - startTime) / 60000);
      tomorrow.setDate(tomorrow.getDate() + 1);
    }

    var excludeDays = $('.estimateTimer').parent("b").find(".dateEstimate").data("delivery_off_days");
    excludeDays = excludeDays.split(" ");
    $.each(excludeDays, function(key, daySingle){
      console.log(daySingle);
      if(daySingle === "SUN"){
        excludeDays[key] = 0;
      }
      if(daySingle === "MON"){
        excludeDays[key] = 1;
      }
      if(daySingle === "TUE"){
        excludeDays[key] = 2;
      }
      if(daySingle === "WED"){
        excludeDays[key] = 3;
      }
      if(daySingle === "THU"){
        excludeDays[key] = 4;
      }
      if(daySingle === "FRI"){
        excludeDays[key] = 5;
      }
      if(daySingle === "SAT"){
        excludeDays[key] = 6;
      }
    });
    if(excludeDays.length >= 7){
      excludeDays = [];
    }
	
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + $('.estimateTimer').parent("b").find(".dateEstimate").data("date"));
    do {
      tomorrow.setDate(tomorrow.getDate() + 1);
    } while($.inArray(tomorrow.getDay(), excludeDays) > -1);
    var fmt = new DateFmt();
    $(".dateEstimate").html(fmt.format(tomorrow,"%w , %n. %d"));

    var hours = Math.floor(timer_time / 60);          
    var minutes = Math.floor(timer_time % 60);

    //     $('#estimateTimer').countdowntimer({
    //       hours : hours,
    //       minutes : minutes,
    //       seconds : 00
    //     });

    var day_wek = fmt.format(tomorrow,"%y") +' '+hours+':'+minutes;
    var countDownDate = new Date(day_wek).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now an the count down date
      var distance = countDownDate - now;

      // Output the result in an element with id="demo"
      $('.estimateTimer').html(hours + " hours " + minutes + " minutes");


      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(x);
        //document.getElementById("estimateTimer").innerHTML = "EXPIRED";
      }
    }, 100);


  }
  function DateFmt() {
    this.dateMarkers = { 
      d:['getDate',function(v) { return ("0"+v).substr(-2,2)}], 
      m:['getMonth',function(v) { return ("0"+v).substr(-2,2)}],
      n:['getMonth',function(v) {
        var mthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        return mthNames[v];
      }],
      w:['getDay',function(v) {
        var dayNames = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        return dayNames[v];
      }],
      y:['getFullYear'],
      H:['getHours',function(v) { return ("0"+v).substr(-2,2)}],
      M:['getMinutes',function(v) { return ("0"+v).substr(-2,2)}],
      S:['getSeconds',function(v) { return ("0"+v).substr(-2,2)}],
      i:['toISOString',null]
    };

    this.format = function(date, fmt) {
      var dateMarkers = this.dateMarkers
      var dateTxt = fmt.replace(/%(.)/g, function(m, p){
        var rv = date[(dateMarkers[p])[0]]()

        if ( dateMarkers[p][1] != null ) rv = dateMarkers[p][1](rv)

        return rv
      });

      return dateTxt
    }
  }
})
document.addEventListener('DOMContentLoaded', function () {
  var elem = document.querySelector('.carousel');
  if(elem){
    var flkty = new Flickity(elem, {
      cellAlign: 'left',
      contain: true,
      autoPlay: true,
      wrapAround: true,
      watchCSS: true,
      adaptiveHeight: true,
      pageDots: true
    });
  }    
});
(function () {
  function updateSwipeHints() {
    document.querySelectorAll(".smf-table-scroll, .deicer-table-scroll")
  .forEach(function (wrap) {

    // Skip horsepower table (it uses custom CSS hint)
    if (wrap.closest("#smf-horsepower")) return;

      // Determine if wrapper is actually scrollable
      var isScrollable = wrap.scrollWidth > wrap.clientWidth + 4;

      // Toggle a class so CSS can decide whether to show hint
      wrap.classList.toggle("has-overflow", isScrollable);

      // Ensure the hint element exists (only once)
      var next = wrap.nextElementSibling;
      var hasHint = next && next.classList && next.classList.contains("smf-swipe-hint");

      if (!hasHint) {
        var hint = document.createElement("p");
        hint.className = "smf-swipe-hint";
        hint.textContent = "Tip: Swipe to view →";
        wrap.insertAdjacentElement("afterend", hint);
      }
    });
  }

  // Initial runs (DOM, then after layout settles)
  document.addEventListener("DOMContentLoaded", function () {
    updateSwipeHints();
    requestAnimationFrame(updateSwipeHints);
    setTimeout(updateSwipeHints, 250);
    setTimeout(updateSwipeHints, 1000);
  });

  // Re-check on resize/orientation changes
  window.addEventListener("resize", updateSwipeHints);

  // Re-check when images finish loading (common cause of late width changes)
  window.addEventListener("load", updateSwipeHints);

  // Bonus: watch wrappers for size changes (best signal if supported)
  if ("ResizeObserver" in window) {
    var ro = new ResizeObserver(function () { updateSwipeHints(); });
    document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll(".smf-table-scroll, .deicer-table-scroll").forEach(function (wrap) {
        ro.observe(wrap);
      });
    });
  }
})();


